<template>
  <v-app>
    <!-- 🔹 Search Form -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search</v-expansion-panel-title>

              <v-form @submit.prevent="submitForSearch">
                <v-row class="pa-2">
                  <v-col lg="4" md="4" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="from_date.value.value"
                      label="From Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month"
                      single-line
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      :error-messages="from_date.errorMessage.value"
                    />
                  </v-col>

                  <v-col lg="4" md="4" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="to_date.value.value"
                      label="To Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month"
                      single-line
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      :error-messages="to_date.errorMessage.value"
                    />
                  </v-col>

                  <v-col lg="2" md="2" cols="12">
                    <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                  </v-col>
                </v-row>
              </v-form>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- 🔹 TAX Register List -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">TAX Register List</v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col lg="4" md="4" cols="12" class="pt-5">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      clearable
                    />
                  </v-col>

                  <v-col lg="6" md="6" cols="12" class="pt-5">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <!-- 🔹 Data Table -->
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  :search="search"
                  :hover="true"
                  density="compact"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>

                  <template v-slot:header.actions>
                    <v-checkbox v-model="selectAll" hide-details density="compact" @change="toggleSelectAll" />
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <div v-if="!item.is_tax_payout" class="text-center">
                      <v-checkbox v-model="item.selected" hide-details density="compact" @change="handleCheckboxChange" />
                    </div>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip v-if="item.is_tax_payout" color="success" size="small" class="text-capitalize">Paid</v-chip>
                    <v-chip v-else color="warning" size="small" class="text-capitalize">Not Paid</v-chip>
                  </template>

                  <template v-slot:item.voucher_date="{ item }">{{ item.voucher_date }}</template>
                  <template v-slot:item.code="{ item }">{{ item.code }}</template>
                  <template v-slot:item.party="{ item }">{{ item.party?.party_name || "" }}</template>
                  <template v-slot:item.account_head="{ item }">{{ item.account_head?.name || "" }}</template>
                  <template v-slot:item.account_code="{ item }">{{ item.account_head?.code || "" }}</template>
                  <template v-slot:item.amount="{ item }">{{ item.amount }}</template>

                  <template v-slot:body.append>
                    <tr style="background-color: #f5f5f5;">
                      <td colspan="8" class="text-right font-weight-bold">Total Amount:</td>
                      <td class="text-end font-weight-bold">{{ totalAmount }}</td>
                      <td></td>
                    </tr>
                  </template>
                </v-data-table>

                <v-container class="d-flex justify-end mt-4 pa-4">
                  <!-- Open modal instead of direct submit -->
                  <v-btn v-if="isAnyTaxSelected" @click="openPayoutModal" color="success" variant="flat" type="button" size="small"> Payout Save </v-btn>
                </v-container>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- =========================
         Payout Modal/Dialog
         ========================= -->
    <v-dialog v-model="payoutModal" max-width="900">
      <v-card class="pa-5">
        <v-card-title>
          <span class="text-h6">TAX Payout</span>
        </v-card-title>

        <v-form @submit.prevent="submitPayout">
          <v-card-text>
            <v-row class="mt-3">
              <v-col cols="12" md="3">
                <v-date-input
                  input-format="dd/mm/yyyy"
                  v-model="voucher_date.value.value"
                  label="Voucher Date *"
                  variant="outlined"
                  density="compact"
                  prepend-icon=""
                  prepend-inner-icon="mdi-calendar"
                  :error-messages="voucher_date.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-model="payment_method.value.value"
                  :items="paymentMethods"
                  item-title="text"
                  item-value="value"
                  label="Payment Method *"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-cash-multiple"
                  :error-messages="payment_method.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="payment_acc_account_head_id.value.value"
                  :items="getPaymentAccountHeadList"
                  :item-title="(item) => item.name ?? 'Select'"
                  item-value="id"
                  label="Payment Account Head"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-bank"
                  clearable
                  :error-messages="payment_acc_account_head_id.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="party.value.value"
                  :items="getPartyList"
                  :item-title="(item) => `${item.name ?? 'N/A'} - ${item.code ?? 'N/A'}`"
                  item-value="id"
                  label="Select Payee"
                  variant="outlined"
                  density="compact"
                  prepend-inner-icon="mdi-account"
                  clearabl
                  :error-messages="party.errorMessage.value"
                />
              </v-col>
            </v-row>

            <v-expand-transition>
              <div v-if="payment_method.value.value === 'BANK'">
                <v-divider class="my-3"></v-divider>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="cheque_no.value.value"
                      label="Cheque No"
                      variant="outlined"
                      density="compact"
                      prepend-inner-icon="mdi-checkbook"
                      :error-messages="cheque_no.errorMessage.value"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="cheque_date.value.value"
                      label="Cheque Date"
                      variant="outlined"
                      density="compact"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      :error-messages="cheque_date.errorMessage.value"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>

            <v-row>
              <v-col>
                <v-textarea
                    v-model="narration.value.value"
                    label="Narration"
                    variant="outlined"
                    density="comfortable"
                    rows="3"
                    maxlength="255"
                    counter
                    placeholder="Enter narration (optional)"
                    :error-messages="narration.errorMessage.value"
                  ></v-textarea>
              </v-col>
            </v-row>

            <!-- show total selected amount (optional) -->
            <v-row class="mt-4 d-none">
              <v-col cols="12" class="text-right">
                <div class="font-weight-medium">Selected TAX Total: {{ totalSelectedAmount }}</div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="closePayoutModal">Cancel</v-btn>
            <v-btn color="success" variant="flat" type="submit" size="small" :loading="loading">Submit</v-btn>
          </v-card-actions>
        </v-form>

      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { ref, computed, watch } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "TaxRegisterWithPayoutModal",
  data: () => ({
    panel1: [0],
    panel2: [0],
    search: "",
    selectAll: false,
    totalSelectedAmount: 0,
    isAnyTaxNotSelected: false,
    headers: [
      { title: "#SL", key: "index", align: "center", width: "7%", sortable: false },
      { title: "Action", key: "actions", align: "left", width: "7%", sortable: false },
      { title: "Status", key: "status", align: "left", width: "7%", sortable: false },
      { title: "Date", key: "voucher_date", align: "center", sortable: true },
      { title: "Voucher No", key: "code", align: "left", sortable: true },
      { title: "Party", key: "party.name", align: "left", sortable: true },
      { title: "Account Head", key: "account_head", align: "center", sortable: true },
      { title: "Account Code", key: "account_code", align: "center", sortable: true },
      { title: "Amount Of TAX", key: "amount", align: "end", sortable: true },
      { title: "Paid Vide Challan No & Date", key: "", align: "end", sortable: false },
    ],
    payoutModal: false,
  }),

  computed: {
    getSchema() {
      return this.$store.getters.getTaxRegisterList || [];
    },
    totalAmount() {
      return this.getSchema.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    },
    getNonCashAccoutHeadList() {
      return this.$store.getters.getNonCashAccoutHeadList;
    },
    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList;
    },
    getConstCentersList() {
      return this.$store.getters.getConstCentersList;
    },
    paymentAccountHeadsLoaded() {
      return (
        this.getPaymentAccountHeadList &&
        this.getPaymentAccountHeadList.length > 0
      );
    },
    getPartyList() {
      return this.$store.getters.getPartyList || [];
    },

    // computed boolean for button visibility (derive from getSchema)
    isAnyTaxSelected() {
      return this.getSchema.some(item => item.selected === true);
    },
  },

  created() {
    // load lists if empty
    if (!this.$store.getters.getTaxRegisterList?.length) {
      this.$store.dispatch("getTaxRegisterList");
    }

    if (this.$store.getters.getNonCashAccoutHeadList.length === 0) {
      this.$store.dispatch("getNonCashAccoutHeadList");
    }

    if (this.$store.getters.getConstCentersList.length === 0) {
      this.$store.dispatch("getConstCentersList");
    }

    if (this.$store.getters.getPartyList.length === 0) {
      this.$store.dispatch("getPartyList");
    }
  },

  setup() {
    const store = useStore();
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });

    const { handleSubmit: handlePayoutSubmit } = useForm({
      validationSchema: yup.object({
        voucher_date: yup.date().required().label("V Date"),
        payment_method: yup.string().required().label("Payment Method"),
        payment_acc_account_head_id: yup.number().required().label("Account Head"),
        party: yup.number().required().label("Party"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const loading = ref(false);

    const voucher_date = useField("voucher_date");
    const payment_method = useField("payment_method");
    const payment_acc_account_head_id = useField("payment_acc_account_head_id");
    const party = useField("party");
    const cheque_no = useField("cheque_no");
    const cheque_date = useField("cheque_date");
    const narration = useField("narration");
    

    const paymentMethods = [
      { text: "Cash", value: "CASH" },
      { text: "Bank", value: "BANK" },
    ];

    watch(
      () => payment_method.value.value,
      (newPaymentMethod) => {
        if (newPaymentMethod) {
          store.dispatch("getPaymentAccountHeadList", { type: newPaymentMethod });
          payment_acc_account_head_id.value.value = "";
        }
      }
    );

    const submitForSearch = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getTaxRegisterList", values)
        .then(() => (loading.value = false))
        .catch((error) => {
          loading.value = false;
          toast.error(error.response?.data?.message || "Error fetching data");
        });
    });

    const submitPayout = handlePayoutSubmit((values) => {
        loading.value = true;

        const tax_items = store.getters.getTaxRegisterList
        .filter(item => item.selected === true)
        .map(item => ({
          id: item.acc_voucher_detail_id,
          amount: item.amount,
        }));

        if (tax_items.length === 0) {
          loading.value = false;
          toast.error("No TAX items selected");
          return;
        }

      const payload = {
        voucher_date: formattedDate(voucher_date.value.value),
        payment_method: payment_method.value.value,
        payment_acc_account_head_id: payment_acc_account_head_id.value.value,
        party_id: party.value.value,
        cheque_no: cheque_no.value.value || null,
        cheque_date: formattedDate(cheque_date.value.value) || null,
        tax_items: tax_items,
        narration: narration.value.value,
      };

      loading.value = true;

      store
        .dispatch("storeTaxPayout", payload)
        .then(() => {
          loading.value = false;
          toast.success("Payout saved successfully");
          getSchema.forEach(item => (item.selected = false));
          selectAll = false;
          totalSelectedAmount = 0;
          payoutModal = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error?.response?.data?.message || "Error saving payout");
        });
    });
    return {
      submitForSearch,
      submitPayout,
      paymentMethods,
      from_date,
      to_date,
      loading,
      voucher_date,
      payment_method,
      payment_acc_account_head_id,
      party,
      narration,
      cheque_no,
      cheque_date,
    };
  },

  methods: {
    toggleSelectAll() {
      this.getSchema.forEach((item) => {
        if (!item.is_tax_payout) item.selected = this.selectAll;
      });
      this.handleCheckboxChange();
    },

    handleCheckboxChange() {
      const selectableItems = this.getSchema.filter(item => !item.is_tax_payout);
      this.totalSelectedAmount = 0;
      this.isAnyTaxNotSelected = false;

      selectableItems.forEach(item => {
        if (item.selected) {
          this.totalSelectedAmount += Number(item.amount || 0);
        } else {
          this.isAnyTaxNotSelected = true;
        }
      });

      // keep selectAll in sync
      if (this.isAnyTaxNotSelected) {
        this.selectAll = false;
      } else {
        // if there are no selectable items this will also set true; that's ok because UI won't show selectAll in that case
        this.selectAll = selectableItems.length > 0;
      }
    },

    // Open modal
    openPayoutModal() {
      // ensure at least one selected
      if (!this.isAnyTaxSelected) {
        return toast.error("No TAX items selected");
      }

      // compute selected total for modal display
      this.totalSelectedAmount = this.getSchema
        .filter(i => i.selected)
        .reduce((s, it) => s + Number(it.amount || 0), 0);

      this.payoutModal = true;
    },

    // Close modal and reset only modal fields (not the selected items)
    closePayoutModal() {
      this.payoutModal = false;
      // reset modal fields
      this.voucher_date.value.value = "";
      this.payment_method.value.value = "";
      this.payment_acc_account_head_id.value.value = "";
      this.party.value.value = null;
      this.narration.value.value = "";
      this.cheque_no.value.value = "";
      this.cheque_date.value.value = "";
    },

    // (Optional) Export methods stubs — keep behavior same as before
    exportToCSV() {
      // Implement or call existing export util
      toast.info("Export to CSV not implemented in this component");
    },
    exportToExcel() {
      toast.info("Export to Excel not implemented in this component");
    },
    exportToPDF() {
      toast.info("Export to PDF not implemented in this component");
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton?.$el?.click();
    });
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>